module.exports = __webpack_public_path__ + "media/images/version_merge/doc_upload_doc_error-5b174f5596c80e62d14d6d58ddfba216.png";